export const PAGE_SIZE = 6;
export const MAX_RETRIES = 7;
export const SEARCH_DELAY = 500;
